// src/component/dashboard/PhotographerDashboard.js

import React, { useEffect, useState } from "react";
import './style.css';
import { Link, useNavigate } from "react-router-dom";
import Display_event from "./Display_event";
import Photographer_detail from "./Photographer_detail";
import InEvent from "./InEvent";
import AssignedEventPhotographer from "./AssignedEventPhotographer";

const Photographer = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [eventID, setEventID] = useState('');
  const [eventName, setEventName] = useState('');
  const [displayPin, setDisplayPin] = useState('');
  const [refresh, setRefresh] = useState(0);
  const [renderEvent, setRenderEvent] = useState(false);

  const [activeView, setActiveView] = useState("assigned"); // "assigned", "profile", or "eventDetail"

  useEffect(() => {
    const auth = localStorage.getItem("user");
    if (!auth) {
      navigate("/login");
      return;
    }
    setUsername(JSON.parse(auth));

    // External CSS & Script for layout
    const link = document.createElement('link');
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js';
    script.integrity = 'sha384-C6RzsynM9kWDrMNeT87bh95OGNyZPhcTNXj1NW7RuBCsyN/o0jlpcV8Qyq46cDfL';
    script.crossOrigin = 'anonymous';

    link.href = 'https://cdn.lineicons.com/4.0/lineicons.css';
    link.rel = 'stylesheet';
    link.type = 'text/css';

    document.head.appendChild(link);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(link);
      document.head.removeChild(script);
    };
  }, []);

  const logout = () => {
  if (window.confirm("Are you sure you want to logout?")) {
    localStorage.clear();
    setTimeout(() => {
      navigate("/login");
    }, 100); // slight delay to ensure smooth navigation
  }
};


  const inevents = (eventID, name, display_pin) => {
    setEventID(eventID);
    setEventName(name);
    setDisplayPin(display_pin);
    setRenderEvent(true);
    setActiveView("eventDetail");
  };

  return (
    <div className="wrapper">
      {/* Sidebar */}
      <aside id="sidebar" className="expand">
        <div className="d-flex">
          <button className="toggle-btn" type="button">
            <i className="lni lni-grid-alt"></i>
          </button>
          <div className="sidebar-logo">
            <a href="#" style={{ fontSize: "25px" }}>PicAura</a>
          </div>
        </div>
        <ul className="sidebar-nav">
          <li className="sidebar-item">
            <Link onClick={() => setActiveView("profile")} className="sidebar-link">
              <i className="lni lni-user"></i>
              <span>Profile</span>
            </Link>
          </li>
          <li className="sidebar-item">
            <Link onClick={() => setActiveView("assigned")} className="sidebar-link">
              <i className="lni lni-camera"></i>
              <span>Assigned Events</span>
            </Link>
          </li>
        </ul>
        <div className="sidebar-footer">
          <Link onClick={logout} className="sidebar-link">
            <i className="lni lni-exit"></i>
            <span>Logout</span>
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <div className="main">
        <nav className="navbar navbar-expand px-4 py-3">
          <div className="navbar-collapse collapse">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item dropdown px-3">
                <a href="#" className="nav-icon pe-md-0">
                  <h4>User: {username.name}</h4>
                </a>
              </li>
            </ul>
          </div>
        </nav>

        <main className="px-3 py-4">
          <div className="container-fluid">
            {/* Conditional Content Rendering */}
            {activeView === "assigned" && (
              <AssignedEventPhotographer onEventClick={inevents} />
            )}

            {activeView === "eventDetail" && renderEvent && (
              <InEvent
                backbtn={() => setActiveView("assigned")}
                setRefresh={setRefresh}
                eventID={eventID}
                name={eventName}
                pin={displayPin}
              />
            )}

            {activeView === "profile" && (
              <Photographer_detail />
            )}
          </div>
        </main>

        <div className="row text-body-secondary footer">
          <div className="col-12">
            <h5>Design by Three Musketeers Infotech (Neha & Shraddha)</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Photographer;
